import Constants from 'Constants'
import { EventBus } from 'EventBus'
import Common from '@/assets/js/common.js'
import _cloneDeep from 'lodash/cloneDeep'

const PaxMixin = {
    methods: {
        getStallions: async function() {
            const url = Constants.PAX_STALLIONS + "?licence_key="+Constants.USER_LICENCE_KEY

			const result = await this.$request.request_get_api("PaxMixin::getStallions", url)
			.catch(error => {
				console.error("PaxMixin::getStallions => ERROR", error)
				return null
			})

			return result ? result.retour : null
        },

        getMares: async function() {
            const url = Constants.PAX_MARES + "?licence_key="+Constants.USER_LICENCE_KEY

			const result = await this.$request.request_get_api("PaxMixin::getMares", url)
			.catch(error => {
				console.error("PaxMixin::getMares => ERROR", error)
				return null
			})

			return result ? result.retour : null
        },

        getCriteres: async function(lang) {
            const url = Constants.PAX_CRITERES + "?licence_key="+Constants.USER_LICENCE_KEY + "&lang=" + lang

			const result = await this.$request.request_get_api("PaxMixin::getCriteres", url)
			.catch(error => {
				console.error("PaxMixin::getCriteres => ERROR", error)
				return null
			})

			return result ? result.retour : null
        },
		

		paxCalculCompatiblite: async function(stallions, criteres) {
			let recap = {}

			let pourcentage_correction = 1-(2*6681/100000)

			for (let index in criteres) {
				if(criteres[index].slider) {
					let valeur_mare = parseFloat(criteres[index].slider)
					const criteres_max = criteres[index].criteres_max / 100
					const criteres_min = criteres[index].criteres_min / 100

					for(let index_stallion in stallions) {
						if(!stallions[index_stallion]) {
							continue;
						}
						let valeur_stallion = stallions[index_stallion].horse_criteres[criteres[index].criteres_id]

						let moyenne = (valeur_stallion + valeur_mare) / 2
						let ecart_maxi = (criteres_max - moyenne)
						let ecart_mini = (criteres_min - moyenne)
						let p1 = null
						let p2 = null

						if(criteres_max == 4) {
							p1 = 100
						}
						else {
							p1 = (this.getProba(ecart_maxi) - 6.6810) / pourcentage_correction
							if(p1 > 100) {
								p1 = 100
							}
						}

						if(criteres_min == 1) {
							p2 = 0
						}
						else {
							p2 = (this.getProba(ecart_mini) - 6.6810) / pourcentage_correction
							if(p2 < 0) {
								p2 = 0
							}
						}

						let p = Math.abs(p1 - p2)

						if(!recap[stallions[index_stallion].horse_id]) {
							recap[stallions[index_stallion].horse_id] = {}
						}
						recap[stallions[index_stallion].horse_id][criteres[index].criteres_id] = Math.round(p)
					}
				}
			}

			return recap
		},
		getProba: function (ecart) {
			let tab_proba = {
				"-4": 0,
				"-3.75": 0,
				"-3.5": 0,
				"-3.25": 0,
				"-3": 0.1350,
				"-2.75": 0.2980,
				"-2.5": 0.6210,
				"-2.25": 1.2220,
				"-2": 2.2750,
				"-1.75": 4.0060,
				"-1.5": 6.6810,
				"-1.25": 10.5650,
				"-1": 15.8660,
				"-0.75": 22.6630,
				"-0.5": 30.8540,
				"-0.25": 40.1290,
				"0": 50.0000,
				"0.25": 59.8710,
				"0.5": 69.1460,
				"0.75": 77.3370,
				"1": 84.1340,
				"1.25": 89.4350,
				"1.5": 93.3190,
				"1.75": 95.9940,
				"2": 97.7250,
				"2.25": 98.7780,
				"2.5": 99.3790,
				"2.75": 99.7020,
				"3":99.8650,
				"3.25": 100,
				"3.5": 100,
				"3.75": 100,
				"4": 100,
			}
			return tab_proba[ecart]
		},

		saveCaracterisationByHorse: async function(horse_id, criteres_id, criteres_value) {
            const url =  this.constructRoute(Constants.PAX_CARACTERISATION_HORSE, { horse_id }) +'?licence_key='+Constants.USER_LICENCE_KEY
            const params = {criteres: [{criteres_id, criteres_value}]}

            const response = await this.$request.request_post_api("PaxMixin::saveCaracterisationByHorse", url, params, false)
            .catch(e => {
                return false
            })

            if(response.code_retour === 0){
                return true
            }
		},

		getCaracterisationByHorse: async function(horse_id) {
            const url =  this.constructRoute(Constants.PAX_CARACTERISATION_HORSE, { horse_id }) +'?licence_key='+Constants.USER_LICENCE_KEY

			const result = await this.$request.request_get_api("PaxMixin::getCaracterisationByHorse", url)
			.catch(error => {
				console.error("PaxMixin::getCaracterisationByHorse => ERROR", error)
				return null
			})

			return result ? result.retour : null
		},

		saveMarePanier: async function(horse_id, stallions_ids) {
            const url =  this.constructRoute(Constants.PAX_PANIER_HORSE, { horse_id }) +'?licence_key='+Constants.USER_LICENCE_KEY

            const response = await this.$request.request_post_api("PaxMixin::saveMarePanier", url, {stallions_ids}, false)
            .catch(e => {
                return false
            })

            if(response.code_retour === 0){
                return true
            }
		},

		getMarePanier: async function(horse_id) {
            const url =  this.constructRoute(Constants.PAX_PANIER_HORSE, { horse_id }) +'?licence_key='+Constants.USER_LICENCE_KEY

			const result = await this.$request.request_get_api("PaxMixin::getMarePanier", url)
			.catch(error => {
				console.error("PaxMixin::getMarePanier => ERROR", error)
				return null
			})

			return result ? result.retour : null
		},

		getInfosPaxGrahique: async function(lang, mare_id, stallion_id) {

            const url =  this.constructRoute(Constants.PAX_GRAPHIQUE_INFOS, { mare_id, stallion_id }) +'?licence_key='+Constants.USER_LICENCE_KEY  + "&lang=" + lang

			const result = await this.$request.request_get_api("PaxMixin::getInfosPaxGrahique", url)
			.catch(error => {
				console.error("PaxMixin::getInfosPaxGrahique => ERROR", error)
				return null
			})

			return result ? result.retour : null
		},

		getPaxColor: async function(recap, critere) {
			const stallion_notation = {}

			for(let stallion in recap) {
				let bullet_points = 0
				
				for (let index = 0; index < critere.length; index++) {
					const element = critere[index];

					if(parseInt(recap[stallion][element.criteres_id]) < element.criteres_red) {
						bullet_points += 1
					}
					else if(parseInt(recap[stallion][element.criteres_id]) >= element.criteres_green) {
						bullet_points += 3
					}
					else if(parseInt(recap[stallion][element.criteres_id]) >= element.criteres_red && parseInt(recap[stallion][element.criteres_id]) < element.criteres_green) {
						bullet_points += 2
					}
				}

				stallion_notation[stallion] = bullet_points
			}

			return stallion_notation
		},
	    printSimulationCroisement: async function(mare, stallion) {
			const url = this.constructRoute(Constants.PAX_SIMULATION_PRINT, {mare_id: mare.horse_id, stallion_id: stallion.horse_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			const result = await this.$request.request_get_api("PaxMixin::printSimulationCroisement", url)
			if(result) {
				Common.base64ToPdf(result, `${mare.horse_nom}_X_${stallion.horse_nom}.pdf`)
				return true
			}
			return null
	    },

		getGeneticIndicator: async function(mare_id, stallions_ids) {
            const url =  this.constructRoute(Constants.PAX_GENETIC_INDICATOR, {mare_id, stallions_ids}) +'?licence_key='+Constants.USER_LICENCE_KEY

			const result = await this.$request.request_get_api("PaxMixin::getGeneticIndicator", url)
			.catch(error => {
				console.error("PaxMixin::getGeneticIndicator => ERROR", error)
				return null
			})

			return result ? result.retour : null
		},

		getGlobalColor: function(grade_color, indicator_color) {
			if(!grade_color || !indicator_color) {
				return 'lightgrey'
			}

			if(grade_color == 'dark_green') {
				if(indicator_color == 'dark_green') return 'dark_green'
				if(indicator_color == 'green') return 'dark_green'
				if(indicator_color == 'yellow') return 'green'
			}
			if(grade_color == 'green') {
				if(indicator_color == 'dark_green') return 'dark_green'
				if(indicator_color == 'green') return 'green'
			}
			if(grade_color == 'yellow') {
				if(indicator_color == 'dark_green') return 'green'
				if(indicator_color == 'red') return 'red'
			}
			if(grade_color == 'red') {
				if(indicator_color == 'yellow') return 'red'
				if(indicator_color == 'red') return 'red'
			}

			return 'yellow'
		},

		getColorBullets: function(stallion_id, recap, criteres, criteres_id = null) {
			if(recap[stallion_id] === undefined) {
				return false
			}

			let criteres_local = _cloneDeep(criteres)

			if(criteres_id != null) {
				criteres_local = criteres_local.filter(elem => {
					return elem.criteres_id == criteres_id
				})
			}

			let tab_bullets = []
			
			for (let index = 0; index < criteres_local.length; index++) {
				const element = criteres_local[index];
				
				if(parseInt(recap[stallion_id][element.criteres_id]) < element.criteres_red) {
					tab_bullets.push('red')
				}
				else if(parseInt(recap[stallion_id][element.criteres_id]) >= element.criteres_green) {
					tab_bullets.push('green')
				}
				else if(parseInt(recap[stallion_id][element.criteres_id]) >= element.criteres_red && parseInt(recap[stallion_id][element.criteres_id]) < element.criteres_green) {
					tab_bullets.push('orange')
				}
			}

			return tab_bullets
		},

		colorGrade: function(stallion_id, recap, criteres) {
			const tab_bullets = this.getColorBullets(stallion_id, recap, criteres)
			if(!tab_bullets || tab_bullets.length < 9) {
				return 'noir'
			}

			const nb_elems = tab_bullets.length
			const nb_elems_green = tab_bullets.filter((elem) => elem == 'green').length
			const nb_elems_red = tab_bullets.filter((elem) => elem == 'red').length
			const nb_elems_orange = tab_bullets.filter((elem) => elem == 'orange').length
			const nb_elems_yellow = tab_bullets.filter((elem) => elem == 'yellow').length

			if(nb_elems <= 11) {
				if(nb_elems_yellow <= 1 && nb_elems_red == 0) return 'dark_green'
				if((nb_elems_yellow == 2 || nb_elems_yellow == 3) && nb_elems_red == 0) return 'green'
				if((nb_elems_yellow <= 2 && nb_elems_red == 1) || ((nb_elems_yellow == 4 || nb_elems_yellow == 5) && nb_elems_red == 0)) return 'yellow'
				if((nb_elems_yellow <= 2 && nb_elems_red >= 2) || (nb_elems_yellow == 3 && nb_elems_red == 1) || (nb_elems_yellow == 6 && nb_elems_red == 0)) return 'orange'
				return 'red'
			}

			if(nb_elems == 12) {
				if(nb_elems_yellow <= 2 && nb_elems_red == 0) return 'dark_green'
				if(nb_elems_yellow == 3 && nb_elems_red == 0) return 'green'
				if((nb_elems_yellow <= 2 && nb_elems_red == 1) || ((nb_elems_yellow == 4 || nb_elems_yellow == 5) && nb_elems_red == 0)) return 'yellow'
				if((nb_elems_yellow <= 2 && nb_elems_red >= 2) || (nb_elems_yellow == 3 && nb_elems_red == 1) || ((nb_elems_yellow == 6 || nb_elems_yellow == 7) && nb_elems_red == 0)) return 'orange'
				return 'red'
			}

			if(nb_elems == 13) {
				if(nb_elems_yellow <= 2 && nb_elems_red == 0) return 'dark_green'
				if((nb_elems_yellow == 3 || nb_elems_yellow == 4) && nb_elems_red == 0) return 'green'
				if((nb_elems_yellow <= 2 && nb_elems_red == 1) || (nb_elems_yellow == 5 && nb_elems_red == 0)) return 'yellow'
				if((nb_elems_yellow <= 2 && nb_elems_red >= 2) || (nb_elems_yellow == 3 && nb_elems_red == 1) || ((nb_elems_yellow == 6 || nb_elems_yellow == 7) && nb_elems_red == 0)) return 'orange'
				return 'red'
			}

			if(nb_elems == 14) {
				if(nb_elems_yellow <= 2 && nb_elems_red == 0) return 'dark_green'
				if((nb_elems_yellow <= 1 && nb_elems_red == 1) || ((nb_elems_yellow == 3 || nb_elems_yellow == 4) && nb_elems_red == 0)) return 'green'
				if(((nb_elems_yellow == 2 || nb_elems_yellow == 3) && nb_elems_red == 1) || ((nb_elems_yellow == 5 || nb_elems_yellow == 6) && nb_elems_red == 0)) return 'yellow'
				if((nb_elems_yellow <= 2 && nb_elems_red >= 2) || (nb_elems_yellow == 4 && nb_elems_red == 1) || ((nb_elems_yellow == 7 || nb_elems_yellow == 8) && nb_elems_red == 0)) return 'orange'
				return 'red'
			}

			if(nb_elems == 15) {
				if(nb_elems_yellow <= 2 && nb_elems_red == 0) return 'dark_green'
				if((nb_elems_yellow == 1 && nb_elems_red == 1) || ((nb_elems_yellow == 3 || nb_elems_yellow == 4 || nb_elems_yellow == 5) && nb_elems_red == 0)) return 'green'
				if(((nb_elems_yellow == 2 || nb_elems_yellow == 3) && nb_elems_red == 1) || (nb_elems_yellow == 6 && nb_elems_red == 0)) return 'yellow'
				if(((nb_elems_yellow == 3 || nb_elems_yellow == 4 || nb_elems_yellow == 5) && nb_elems_red >= 2) || (nb_elems_yellow == 4 && nb_elems_red == 1)  || ((nb_elems_yellow == 7 || nb_elems_yellow == 8) && nb_elems_red == 0)) return 'orange'
				return 'red'
			}

			if(nb_elems == 16) {
				if(nb_elems_yellow <= 3 && nb_elems_red == 0) return 'dark_green'
				if((nb_elems_yellow <= 1 && nb_elems_red == 1) || ((nb_elems_yellow == 4 || nb_elems_yellow == 5) && nb_elems_red == 0)) return 'green'
				if((nb_elems_yellow <= 1 && nb_elems_red >= 2) || ((nb_elems_yellow == 2 || nb_elems_yellow == 3) && nb_elems_red == 1) || ((nb_elems_yellow == 6 || nb_elems_yellow == 7) && nb_elems_red == 0)) return 'yellow'
				if(((nb_elems_yellow == 2 || nb_elems_yellow == 3 || nb_elems_yellow == 4) && nb_elems_red >= 2) || ((nb_elems_yellow == 4 || nb_elems_yellow == 5) && nb_elems_red == 1) || (nb_elems_yellow >= 8 && nb_elems_red == 0)) return 'orange'
				return 'red'
			}

			if(nb_elems == 17) {
				if(nb_elems_yellow <= 3 && nb_elems_red == 0) return 'dark_green'
				if((nb_elems_yellow <= 2 && nb_elems_red == 1) || ((nb_elems_yellow == 4 || nb_elems_yellow == 5 || nb_elems_yellow == 6) && nb_elems_red == 0)) return 'green'
				if((nb_elems_yellow <= 2 && nb_elems_red >= 2) || (nb_elems_yellow == 3 && nb_elems_red == 1) || (nb_elems_yellow == 7 && nb_elems_red == 0)) return 'yellow'
				if(((nb_elems_yellow == 3 || nb_elems_yellow == 4) && nb_elems_red >= 2) || ((nb_elems_yellow == 4 || nb_elems_yellow == 5) && nb_elems_red == 1) || (nb_elems_yellow >= 8 && nb_elems_red == 0)) return 'orange'
				return 'red'
			}

			if(nb_elems == 18) {
				if(nb_elems_yellow <= 3 && nb_elems_red == 0) return 'dark_green'
				if((nb_elems_yellow <= 2 && nb_elems_red == 1) || ((nb_elems_yellow == 4 || nb_elems_yellow == 5 || nb_elems_yellow == 6) && nb_elems_red == 0)) return 'green'
				if((nb_elems_yellow <= 2 && nb_elems_red >= 2) || ((nb_elems_yellow == 3 || nb_elems_yellow == 4) && nb_elems_red == 1) || ((nb_elems_yellow == 7 || nb_elems_yellow == 8) && nb_elems_red == 0)) return 'yellow'
				if(((nb_elems_yellow == 3 || nb_elems_yellow == 4) && nb_elems_red >= 2) || (nb_elems_yellow == 5 && nb_elems_red == 1) || (nb_elems_yellow >= 9 && nb_elems_red == 0)) return 'orange'
				return 'red'
			}

			if(nb_elems == 19) {
				if(nb_elems_yellow <= 4 && nb_elems_red == 0) return 'dark_green'
				if((nb_elems_yellow <= 3 && nb_elems_red == 1) || ((nb_elems_yellow == 5 || nb_elems_yellow == 6) && nb_elems_red == 0)) return 'green'
				if((nb_elems_yellow <= 3 && nb_elems_red >= 2) || (nb_elems_yellow == 4 && nb_elems_red == 1) || ((nb_elems_yellow == 7 || nb_elems_yellow == 8) && nb_elems_red == 0)) return 'yellow'
				if((nb_elems_yellow == 4 && nb_elems_red >= 2) || ((nb_elems_yellow == 5 || nb_elems_yellow == 6) && nb_elems_red == 1) || (nb_elems_yellow >= 9 && nb_elems_red == 0)) return 'orange'
				return 'red'
			}

			if(nb_elems == 20) {
				if(nb_elems_yellow <= 4 && nb_elems_red == 0) return 'dark_green'
				if((nb_elems_yellow <= 3 && nb_elems_red == 1) || (nb_elems_yellow == 5 && nb_elems_red == 0)) return 'green'
				if((nb_elems_yellow <= 3 && nb_elems_red >= 2) || ((nb_elems_yellow == 4 || nb_elems_yellow == 5) && nb_elems_red == 1) || (nb_elems_yellow >= 8 && nb_elems_red == 0)) return 'yellow'
				if(((nb_elems_yellow == 4 || nb_elems_yellow == 5) && nb_elems_red >= 2) || ((nb_elems_yellow == 6 || nb_elems_yellow == 7 || nb_elems_yellow == 8) && nb_elems_red == 1)) return 'orange'
				return 'red'
			}

			if(nb_elems == 21) {
				if(nb_elems_yellow <= 5 && nb_elems_red == 0) return 'dark_green'
				if((nb_elems_yellow <= 3 && nb_elems_red == 1) || ((nb_elems_yellow == 6 || nb_elems_yellow == 7) && nb_elems_red == 0)) return 'green'
				if((nb_elems_yellow <= 3 && nb_elems_red >= 2) || ((nb_elems_yellow == 4 || nb_elems_yellow == 5) && nb_elems_red == 1) || (nb_elems_yellow >= 8 && nb_elems_red == 0)) return 'yellow'
				if(((nb_elems_yellow == 4 || nb_elems_yellow == 5) && nb_elems_red >= 2) || ((nb_elems_yellow == 6 || nb_elems_yellow == 7 || nb_elems_yellow == 8) && nb_elems_red == 1)) return 'orange'
				return 'red'
			}

			return 'noir'
		}

    }
}

export default PaxMixin